export const CHECKLIST_FILTERS = {
  ESSENTIALS: {
    value: 'ESSENTIALS',
    label: 'Essentials',
    filterGroup: 'By Task Type',
  },
  CUSTOM: {
    value: 'CUSTOM',
    label: 'Your Custom Tasks',
    filterGroup: 'By Task Type',
  },
  ASSIGNED_TO_YOU: {
    value: 'ASSIGNED_TO_YOU',
    label: 'Assigned to You',
    filterGroup: 'By Task Type',
  },
  TRADITIONS: {
    value: 'TRADITIONS',
    label: 'Your Traditions',
    filterGroup: 'By Task Type',
  },
  COMPLETED: {
    value: 'COMPLETED',
    label: 'Completed',
    filterGroup: 'By Task Type',
  },
  PAST_DUE: {
    value: 'PAST_DUE',
    label: 'Past Due',
    filterGroup: 'By Due Date',
  },
  NEXT_30_DAYS: {
    value: 'NEXT_30_DAYS',
    label: 'Next 30 Days',
    filterGroup: 'By Due Date',
  },
  NEXT_60_DAYS: {
    value: 'NEXT_60_DAYS',
    label: 'Next 60 Days',
    filterGroup: 'By Due Date',
  },
  NEXT_90_DAYS: {
    value: 'NEXT_90_DAYS',
    label: 'Next 90 Days',
    filterGroup: 'By Due Date',
  },
};

export default {
  CHECKLIST_FILTERS,
};



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/constants.js